// extracted by mini-css-extract-plugin
export default {"wrap":"VerticalMiddleWrapper_wrap__sr6sK"};